/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Delete_HintInputs */



/**
* | output |
* | --- |
* | "Once you delete a space, all files and embeddings within it will be permanently removed. This action cannot be undone." |
*
* @param {Spaces_Delete_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_delete_hint = /** @type {((inputs?: Spaces_Delete_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Delete_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn du einen Space löschst, werden alle Dateien und Einbettungen darin unwiderruflich entfernt. Diese Aktion kann nicht rückgängig gemacht werden.")
	return /** @type {LocalizedString} */ ("Once you delete a space, all files and embeddings within it will be permanently removed. This action cannot be undone.")
});